import React from "react";
import sideLinks from "./links";
import { Nav } from "./nav";
import { useAuth } from "../../context/Auth";
import { Link, useNavigate } from "react-router-dom";
import Ad from "../ad";
import { Avatar } from "../avatar";
import RightEvents from "../right-events";
import { Authorization, LogoutModal } from "../authorization";

export const Sidebar = () => {
  const {
    togglePremiumModal,
    user,
    subscriptionData,
    userCheck,
    isNavOpen,
    setNavOpen,
  } = useAuth();

  const navigate = useNavigate();

  return (
    <>
      {isNavOpen ? (
        <div className="mobile-open-nav-bg">
          <i
            onClick={() => setNavOpen(false)}
            className="feather-x-circle text-grey-900 font-sm btn-round-md bg-greylight modal-close-btn"
          />
        </div>
      ) : null}

      <nav className={`navigation scroll-bar ${isNavOpen ? "nav-active" : ""}`}>
        <div className="container ps-0 pe-0">
          <div className="nav-content">
            {user?.user ? (
              <Link className="login-user" to={`/user/${user?.user?.user_name || user?.user?.id}`}>
                <span className="p-2 text-center ms-3 menu-icon center-menu-icon d-inline-block">
                  <Avatar user={user?.user} className={"w50 h50"} />
                </span>
                <h4 className="fw-700 text-grey-900 font-xss mt-1 header-username text-current">
                  {user?.user?.pref_first_name || user?.user?.first_name} {" "} {user?.user?.last_name}
                  {/* <span className="d-block font-xssss fw-500 lh-3 text-grey-500">
                    {user?.user?.email}
                  </span> */}
                  <span className="flex">
                    {user &&
                      subscriptionData &&
                      subscriptionData?.isSubscribed ? (
                      <span className="premium-badge d-block">Premium</span>
                    ) : null}
                    {user?.user?.professional === "yes" ? (
                      <span className="badge-wrapper">
                        <span className="professional-badge" style={{ position: 'relative', top: 2 }}></span>
                      </span>
                    ) : null}
                  </span>
                </h4>
              </Link>
            ) : null}
            {user?.user?.MembershipNumber ? <h4 className="text-grey-900 font-xss flex">
              <a style={{ visibility: 'hidden' }} className="p-2 text-center ms-1 menu-icon center-menu-icon"><img src="https://newmembersdev.icompetenatural.com/alphabet/J.png" alt="image" className="shadow-sm rounded-circle  w50 h5" /></a>
              <span>ICN Member #  <span className="bold">{user?.user?.MembershipNumber}</span></span>
            </h4> : null}
            {user && subscriptionData && !subscriptionData?.isSubscribed ? (
              <button
                className="ms-auto mt-2 mb-2 border-0 p-2 lh-20 w250 bg-mini-gradiant text-white text-center font-xssss fw-600 ls-1 rounded-xl"
                onClick={togglePremiumModal}
              >
                Purchase Premium Membership
              </button>
            ) : null}
            {sideLinks({ user, navigate, userCheck, subscriptionData })?.map(
              (item, index) => (
                <Nav key={`sidebar-${index}`} {...item} />
              )
            )}

            <RightEvents />
            <div className="show-lg">
              {user ? <LogoutModal /> : null}
            </div>
            {/* <a
              href="https://paul7852.wixsite.com/pa-comp-coach?fbclid=IwAR0o_0crnQAWkt0sLAcHldSl8gj0oRP8mP2APKUl_QY8IE3apRgQToT28m0"
              target="_blank"
              className="card w-100 shadow-xss rounded-xxl border-0 mb-3 mt-3 bg-none"
            >
              <img src="./images/advert1.jpg" className="rounded-xxl" />
            </a> */}
            <div className="widget badges">
              <h3> Status Icons Index </h3>
              <ul>
                <li>
                  <span className="badge-wrapper">
                    <span className="contests-number-badge">10</span>
                  </span>
                  <span className="badge-description">
                    Contests entered in iCompete
                  </span>
                </li>
                <li>
                  <span className="badge-wrapper">
                    <span className="representing-badge" />
                  </span>
                  <span className="badge-description">Represented Country</span>
                </li>
                <li>
                  <span className="badge-wrapper">
                    <span className="pq-badge" />
                  </span>
                  <span className="badge-description">
                    Eligible to enter PRO Qualifiers
                  </span>
                </li>
                <li>
                  <span className="badge-wrapper">
                    <span className="professional-badge" />
                  </span>
                  <span className="badge-description">Professional Competitor</span>
                </li>
                <li>
                  <span className="badge-wrapper">
                    <span className="vip-badge" />
                  </span>
                  <span className="badge-description">Official</span>
                </li>
              </ul>
            </div>
            {/* <div className="App">
              <Ad
                path="/37678685/IC_Left_Bottom_250X250"
                width={250}
                height={250}
              />
            </div> */}
            <ul className="mt-3 mb-3">
              <li className="small-link">
                <span className="tc-privacy">
                  <Link onClick={() => setNavOpen(false)} to="/privacy-policy">
                    Privacy Policy &nbsp; 
                  </Link>
                  {" | "}
                  <Link onClick={() => setNavOpen(false)} to="/terms-and-conditions">
                      &nbsp; Terms &amp; Conditions
                  </Link>
                </span>
              </li>
            </ul>
            <div className="widget">
              <div className="copyright">
                © 2016–2026 Natural Icons Pty. Ltd. trading as iCompete Natural (ICN).
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};
